module.exports = __webpack_public_path__ + "img/gold-badge-320.d9b71d1b.png";